import MUIBox, { BoxProps as MUIBoxProps } from "@mui/material/Box"
import React from "react"
import { MUIMappedBox } from "./mantine/Box.mantine"

export type BoxProps =
  | ({ new?: false } & MUIBoxProps)
  | ({ new: true } & MUIBoxProps)

export const Box = React.forwardRef<HTMLElement, BoxProps>((props, ref) =>
  props.new ? (
    <MUIMappedBox ref={ref} {...props} />
  ) : (
    <MUIBox ref={ref} {...props} />
  ),
)

Box.displayName = "Box"

export default Box
